module.exports = __webpack_public_path__ + "static/media/Sell-an-unwanted-cars.dbd33040.jpg";